import { cn } from '@/lib/utils';

export const SettingsContainer = ({
  className,
  ...props
}: React.HtmlHTMLAttributes<HTMLDivElement>) => (
  <section
    className={cn(
      'box-border flex size-full flex-col items-center overflow-auto bg-[#fafafa] [scrollbar-gutter:stable]',
      className
    )}
  >
    {props.children}
  </section>
);

export const SettingsContent = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <section
    className="flex w-full justify-center overflow-x-clip p-8"
    {...props}
  >
    <div className={cn('flex w-full max-w-7xl flex-col', className)}>
      {props.children}
    </div>
  </section>
);

export const SettingsHeaderContainer = (
  props: React.HTMLAttributes<HTMLDivElement>
) => (
  <section className="flex w-full justify-center border-gray-200 border-b border-solid p-8">
    <div className="w-full max-w-7xl">{props.children}</div>
  </section>
);

type SettingHeaderProps = {
  title: string;
  description: string;
};

export const SettingHeader = ({ title, description }: SettingHeaderProps) => (
  <SettingsHeaderContainer>
    <h1 className="mb-2 text-2xl">{title}</h1>
    <p className="text-gray-500 text-sm">{description}</p>
  </SettingsHeaderContainer>
);
